import { MobileContext } from '@hooks/use-mobile-context'
import React from 'react'
import { defaultMobileState, reducer } from '@store/mobile-reducer.ts'

const MobileContextProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [state, dispatch] = React.useReducer(reducer, defaultMobileState)
	return (
		<MobileContext.Provider value={{ state, dispatch }}>
			{children}
		</MobileContext.Provider>
	)
}

export { MobileContextProvider }
